// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"5f927beb","516":"6cc616ba","787":"19003d94","892":"45c46673"}[chunkId] + ".chunk.js";
};